import { formatPersOrgNr } from '../../lib/formatPersnr';

interface ForetagPersonOrganizationProps {
  persOrgNr: string;
  note: string;
}

export const ForetagPersonOrganization: React.FC<
  ForetagPersonOrganizationProps
> = ({ persOrgNr, note }) => {
  return (
    <>
      {formatPersOrgNr(persOrgNr)}
      {note && (
        <>
          <br />
          {note}
        </>
      )}
    </>
  );
};
